import * as types from '../mutation-types'
const state = {
  profileUser: ''
}
const getters = {
  getProfileUser (state) {
    return state.profileUser
  }
}
const mutations = {
  [types.STORE_PROFILE_USER] (state, data) {
    state.profileUser = data
  }
}
const actions = {

}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/candidateProfile.js